import { SourcingService } from 'api-clients/monolith';

export type RunningPostingBatches = Awaited<
  ReturnType<typeof SourcingService.getInternalApiSourcingPostingBatchesRunning>
>;

/** `openingId` is the opening's external id; omit it for the whole account. */
export function getRunningPostingBatches(openingId?: string) {
  return SourcingService.getInternalApiSourcingPostingBatchesRunning(openingId);
}
